<template>
  <div class="filters-container row">
    <div class="col-md-6 ">
      <input
        type="text"
        class="form-control"
        placeholder="Buscar empresa..."
        v-model="searchQuery"
        @input="emitFilters"
      />
    </div>
    <div class="col-md-6">
      <select class="form-select" v-model="sortBy" @change="emitFilters">
        <option value="">Ordenar por</option>
        <option value="media_notas_asc">Média ↑</option>
        <option value="media_notas_desc">Média ↓</option>
        <option value="respostas_asc">Respostas ↑</option>
        <option value="respostas_desc">Respostas ↓</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NpsColumnFilters',
  emits: ['filter-change'],
  data() {
    return {
      searchQuery: '',
      sortBy: ''
    }
  },
  methods: {
    emitFilters() {
      this.$emit('filter-change', {
        searchQuery: this.searchQuery,
        sortBy: this.sortBy
      });
    }
  }
}
</script>

<style scoped>
.filters-container {
  padding: 8px 0px 8px 0px;
}
.form-select {
  font-size: 0.875rem;
}
</style>
